<!--
 * @Author: your name
 * @Date: 2021-08-26 17:15:19
 * @LastEditTime: 2022-09-22 18:08:03
 * @LastEditTime: 2021-08-30 16:53:11
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\stock\out\index.vue
-->
<template>
  <div class="app-container">
    <BjRouteTabs />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="false"
      :before-reset-search="beforeResetSearch"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('form.oddNumbers')" prop="queryCode">
            <BjInputCode
              v-model="queryParams.queryCode"
              :placeholder="$t('BusinessStockEntryInform.header.queryCodeText')"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <BjSelectChannelStore
          :span="colSpan"
          :query-params="queryParams"
          :query-props="['channelTypeCode', 'storeIdList']"
          store-option-value="id"
          multiple
        />
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockEntryInform.header.status')" prop="status">
            <BjSelectLov v-model="queryParams.status" lov-code="STOCK.INPUT_STATUS" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockEntryInform.header.receivingLogicWarehouseCode')" prop="receivingLogicWarehouseCode">
            <BjInput
              v-model="queryParams.receivingLogicWarehouseCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('BusinessStockEntryInform.header.receivingLogicWarehouseCodeText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockEntryInform.header.beginCreationDate')" prop="beginCreationDate">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('BusinessStockEntryInform.header.beginCreationDate')"/>
          </el-form-item>
        </el-col>
      </template>
      <!-- <template v-slot:tableOperation>
        <el-col>
            <el-button type="primary" >按 钮</el-button>
          </el-col>
        </div>
      </template> -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <div v-if="['code', 'platformOrderCode', 'orderCode'].includes(col.prop)">
                <span class="link" @click="onView(scope.row, col.prop)">{{
                  scope.row[col.prop]
                }}</span>

                <BjCopyIcon class="ml10" :copy="scope.row[col.prop]" />
              </div>
              <template v-else-if="col.prop === 'status'">
                {{ STOCK_INPUT_STATUS.bjGet(scope.row[col.prop]) }}</template
              >
              <template v-else-if="col.prop === 'inputTypeMeaning'">
                {{ STOCK_INPUT_TYPE.bjGet(scope.row[col.prop]) }}</template
              >
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button type="text" >按钮</el-button>
            </template>
          </el-table-column> -->
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
export default {
  name: 'BusinessStockEntryInformIndex',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 8,

      queryApi: stockApi.getEntryInform,
      // 查询参数
      queryParams: {
        queryCode: null,
        channelTypeCode: null,
        storeIdList: [],
        status: null,
        receivingLogicWarehouseCode: null,
        beginCreationDate: null,
        endCreationDate: null,
      },
      queryParamsTime: null,
      labelsVersion: 11,
      labelList: [
        { label: 'BusinessStockEntryInform.table.code', prop: 'code', isCheck: true, disabled: false, width: '210' },
        {
          label: 'BusinessStockEntryInform.table.platformOrderCode',
          prop: 'platformOrderCode',
          isCheck: true,
          disabled: false,
          width: '200',
        },
        { label: 'BusinessStockEntryInform.table.orderCode', prop: 'orderCode', isCheck: true, disabled: false, width: '180' },
        {
          label: 'BusinessStockEntryInform.table.frontRecordCode',
          prop: 'frontRecordCode',
          isCheck: true,
          disabled: false,
          width: '180',
        },
        { label: 'BusinessStockEntryInform.table.inputTypeMeaning', prop: 'inputTypeMeaning', isCheck: true, disabled: false, width: '140' },
        { label: 'BusinessStockEntryInform.table.statusMeaning', prop: 'statusMeaning', isCheck: true, disabled: false, width: '140' },
        { label: 'BusinessStockEntryInform.table.qty', prop: 'qty', isCheck: true, disabled: false, width: '180' },
        {
          label: 'BusinessStockEntryInform.table.receivingLogicWarehouseCode',
          prop: 'receivingLogicWarehouseCode',
          isCheck: true,
          disabled: false,
          width: '230',
        },
        {
          label: 'BusinessStockEntryInform.table.receivingLogicWarehouseName',
          prop: 'receivingLogicWarehouseName',
          isCheck: true,
          disabled: false,
          width: '235',
        },
        { label: 'BusinessStockEntryInform.table.storeName', prop: 'storeName', isCheck: true, disabled: false, width: '100' },
        { label: 'BusinessStockEntryInform.table.channelTypeCodeMeaning', prop: 'channelTypeCodeMeaning', isCheck: true, disabled: false, width: '130' },
        { label: 'BusinessStockEntryInform.table.creationDate', prop: 'creationDate', isCheck: true, disabled: false, width: '130' },
        // { label: '操作', prop: 'bjTableAction', isCheck: true, disabled: true, width: 129},
      ],
    };
  },
  computed: {
    STOCK_INPUT_TYPE() {
      return this.$store.state.values.STOCK_INPUT_TYPE || [];
    },
    STOCK_INPUT_STATUS() {
      return this.$store.state.values.STOCK_INPUT_STATUS || [];
    },
  },
  watch: {
    queryParamsTime(v) {
      this.queryParams.beginCreationDate = (v || [])[0];
      this.queryParams.endCreationDate = (v || [])[1];
    },
  },
  created() {},
  mounted() {
    // this.$store.dispatch('values/getValueList', 'STOCK.INPUT_TYPE');
    this.$store.dispatch('values/getValueList', 'STOCK.INPUT_STATUS');
  },
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      this.queryParams.storeIdList = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 跳转 */
    onView(row, type) {
      if (type === 'code') {
        // this.$toPage('BusinessStockDeliveryInformView', { id: row.id });
        this.$toBusinessStockEntryInformView(row[type]);
      }
      /** 三方单详情 */
      if (type === 'platformOrderCode') {
        this.$toBusinessThirdOrderView(row[type]);
      }
      /** 内部单详情 */
      if (type === 'orderCode') {
        this.$toBusinessOrderInternalView(row[type]);
      }
      // if (type === 'frontRecordCode') {
      //   this.msgSuccess('跳转前置页面');
      // }
    },
  },
};
</script>
<style lang="scss" scoped></style>
